export const PHASE_STRIP_ITEM_STATE = {
  done: 'done',
  needsYou: 'needs_you',
  open: 'open',
}

export const PHASE_STATE = {
  active: 'active',
  done: 'done',
  upcoming: 'upcoming',
}
